import { CompanyAddressDto, PersonAddressDto } from 'dtos'

export function formatAddress(address: CompanyAddressDto | PersonAddressDto, showCountry: boolean = true): string {
  let result = ''

  result += address.address1

  if (address.address2) {
    result += ', ' + address.address2
  }

  result += ', ' + address.city

  result += ', ' + address.stateProvince

  result += ' ' + address.postalCode

  if (showCountry) {
    result += ' ' + address.country
  }

  return result
}
